import {makeChannelOptionHtml} from "./ChannelOptionHtml";

export function makeTravelokaChannelOptionHtml() {
    const innerHtml = 'Traveloka';
    const html = makeChannelOptionHtml(innerHtml, [
        'background: #1BA0E2;',
    ]);
    return html;
}
